import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-527e3677"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar_header" }
const _hoisted_2 = {
  key: 1,
  class: "calendar_header__week"
}

import { PropType } from 'vue'
import { CalendarType } from '@/models/google.model'
import {
  formatIntlDateNumeric,
  formatIntlShortDateNumeric,
  formatIntlShortWeekday,
  formatIntlWeekday,
} from '@/utils/formatters'
import { isToday } from 'date-fns'


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarHeader',
  props: {
  calendarType: {
    type: String as PropType<CalendarType>,
    required: true,
  },
  days: {
    type: Array as PropType<Date[]>,
    default: () => [],
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.calendarType === _unref(CalendarType).DAY)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["calendar_header__day", _unref(isToday)(__props.days[0]) && 'calendar_header__day--today'])
        }, [
          _createElementVNode("div", null, _toDisplayString(_unref(formatIntlWeekday)(__props.days[0])), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(formatIntlDateNumeric)(__props.days[0])), 1)
        ], 2))
      : (__props.calendarType === _unref(CalendarType).WEEK)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.days, (day) => {
              return (_openBlock(), _createElementBlock("div", {
                key: day,
                class: _normalizeClass(["calendar_header__day calendar_header__shortened-label", _unref(isToday)(day) && 'calendar_header__day--today'])
              }, [
                _createElementVNode("div", null, _toDisplayString(_unref(formatIntlShortWeekday)(day)), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(formatIntlShortDateNumeric)(day)), 1)
              ], 2))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.days, (day) => {
              return (_openBlock(), _createElementBlock("div", {
                key: day,
                class: _normalizeClass(["calendar_header__day calendar_header__full-length-label", _unref(isToday)(day) && 'calendar_header__day--today'])
              }, [
                _createElementVNode("div", null, _toDisplayString(_unref(formatIntlWeekday)(day)), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(formatIntlDateNumeric)(day)), 1)
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})